/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:block;height:100%;min-height:0;max-height:100%}.fullscreen[_ngcontent-%COMP%], app-vehicle-service-details-tab-fleet-manager-comments[_ngcontent-%COMP%], app-vehicle-service-details-tab-invoices[_ngcontent-%COMP%]{height:100%}.dx-item-content[_ngcontent-%COMP%]{display:flex;flex-direction:column}"];
export { styles as styles };
